/**
 * Milliseconds a TOAST stays mounted before auto-dismiss. NotificationService
 * stamps expires_at at send time, so a toast that arrives late can already be
 * past it; showing it for the fallback dwell beats dismissing it before its
 * entry animation becomes visible. No expiry also means the fallback.
 */
export const TOAST_FALLBACK_DISMISS_MS = 5000;

/** Longest toast entry animation (free play, 720 ms) plus a little read time. */
export const TOAST_MIN_DISMISS_MS = 1000;

export const toastDismissDelayMs = (expiresAtMs: number | null, nowMs: number): number => {
  if (expiresAtMs === null) return TOAST_FALLBACK_DISMISS_MS;
  const remaining = expiresAtMs - nowMs;
  return remaining >= TOAST_MIN_DISMISS_MS ? remaining : TOAST_FALLBACK_DISMISS_MS;
};
